// extracted by mini-css-extract-plugin
export var csatScore = "_f2-5";
export var header = "_f2-1";
export var panelWrapper = "_f2-2";
export var postPreview = "_f2-3";
export var rightContent = "_f2-0";
export var wrappingText = "_f2-4";